<template>

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/accountancy')">Contabilidad</li>
        <li class="breadcrumb-item active" aria-current="page">Carga de Estados de Cuenta</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row justify-content-md-center" style="margin-top:20px;">
        <div class="col-md-12">
          <md-card>
            <md-card-content>
              <div class="row justify-content-md-center">
                <div class="col-md-5">
                  <md-datepicker v-model="fecha" md-immediately :md-disabled-dates="disabledDates">
                    <label>Fecha:</label>
                  </md-datepicker>
                  <small>*Al cambiar la fecha, se limpia la vista</small>
                </div>
                <div class="col-md-2"/>
                <div class="col-md-5">
                  <md-field>
                    <label>Banco</label>
                    <md-select v-model="bank">
                      <md-option selected disabled v-if="catalog == null">Cargando catalogo...</md-option>
                      <md-option selected disabled v-if="catalog === []">No hay bancos registrados</md-option>
                      <md-option v-for="renglon in catalog" :key="renglon.bcid" :value="renglon.bcid">{{renglon.bank}} - {{renglon.clabe}}</md-option>
                    </md-select>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <div class="row justify-content-md-center" v-if="bank!=null && fecha!=null" style="margin-top:20px;">
        <div class="col-md-12">
          <md-card>
            <md-card-content>
              <div v-for="mensaje in mensajes">
                <p style="color: red"><strong>*{{mensaje}}</strong></p>
              </div>

              <md-table style="text-align: center">
                <md-table-row>
                  <md-table-head style="text-align: center">Fecha</md-table-head>
                  <md-table-head style="text-align: center">Descripción</md-table-head>
                  <md-table-head style="text-align: center">Referencia</md-table-head>
                  <md-table-head style="text-align: center">Cargo</md-table-head>
                  <md-table-head style="text-align: center">Abono</md-table-head>
                  <md-table-head style="text-align: center">Saldo</md-table-head>
                  <md-table-head style="text-align: center">Concepto</md-table-head>
                </md-table-row>
                <md-table-row v-for="(renglon,index) in data" :key="index">
                  <md-table-cell style="text-align: center">{{renglon.fecha}}</md-table-cell>
                  <md-table-cell style="text-align: center">{{renglon.descripcion}}</md-table-cell>
                  <md-table-cell style="text-align: center">{{renglon.referencia}}</md-table-cell>
                  <md-table-cell style="text-align: center">{{renglon.cargo}}</md-table-cell>
                  <md-table-cell style="text-align: center">{{renglon.abono}}</md-table-cell>
                  <md-table-cell style="text-align: center">{{renglon.saldo}}</md-table-cell>
                  <md-table-cell style="text-align: center">{{renglon.concepto}}</md-table-cell>
                </md-table-row>
                <md-table-row v-if="loading === true">
                  <md-table-cell style="text-align: center" colspan="7">
                    <md-progress-spinner :md-diameter="40" :md-stroke="5" md-mode="indeterminate"/>
                  </md-table-cell>
                </md-table-row>
                <md-table-row v-else-if="data.length === 0">
                  <md-table-cell style="text-align: center" colspan="7">No se encontraron movimientos</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <div class="row justify-content-md-center" v-if="bank!=null && fecha!=null" style="margin-top:20px;">
        <div class="col-md-12">
          <md-card>
            <md-card-content>
              <div class="row">
                <div class="col-md-6">
                  <label>Antes de seleccionar el archivo a cargar verifica lo siguiente:</label>
                  <md-checkbox v-model="containHeaders">¿Nombre de las columnas en la primera fila?</md-checkbox>
                  <p v-if="containHeaders" style="color: red"><strong>*Verifica que las cabeceras sean estas: fecha,descripcion,referencia,cargo,abono,saldo,concepto</strong></p>
                  <md-field>
                    <label>Cargar Archivo:</label>
                    <md-file v-model="file" @change="loadCSV($event)"/>
                  </md-field>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <div class="row justify-content-md-center" v-if="bank!=null && fecha!=null" style="margin-top:20px;">
        <div class="col-md-12">
          <md-card>
            <md-card-content>
              <div class="row">
                <div class="col-md-3" style="text-align: center">
                  <md-button class="md-raised md-primary" @click="mostrar()"><md-icon>publish</md-icon>Cargar</md-button>
                </div>
                <div class="col-md-3" style="text-align: center">
                  <md-button class="md-raised md-primary" @click="noMovements()"><md-icon>exposure_zero</md-icon>Sin Movimientos</md-button>
                </div>
                <div class="col-md-3" style="text-align: center">
                  <md-button class="md-raised md-primary" @click="saveMovements()"><md-icon>save</md-icon>Guardar</md-button>
                </div>
                <div class="col-md-3" style="text-align: center">
                  <p v-if="show"><strong>¿Seguro?</strong></p>
                  <md-button class="md-raised md-primary" v-if="!show" @click="show=true"><md-icon>delete</md-icon>Borrar</md-button>
                  <md-button class="md-raised md-primary" style="background-color:green" v-if="show" @click="deleteDayMovements()"><md-icon>delete</md-icon>Si</md-button>
                  <md-button class="md-raised md-primary" style="background-color:red" v-if="show" @click="show=false"><md-icon>clear</md-icon>No</md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
  export default  {
    name: 'account-statements',
    props: [],
    mounted() {
      this.fecha = this.getTo();
      this.getBanksCatalog();
    },
    data() {
      return {
        data: [],
        catalog: null,
        today: new Date(),
        fecha: null,
        file: null,
        bank: null,
        disabledDates: date => {
          return date >= this.today ||
                  (date.getFullYear() === this.today.getFullYear() &&
                          date.getMonth() === this.today.getMonth() &&
                          date.getDate() === this.today.getDate());
        },
        parse_csv: [],
        parse_header: [],
        sortOrders:{},
        containHeaders: false,
        mensajes: [],
        show: false,
        loading: false,
      }
    },
    methods: {
      getTo(){
        var date = new Date();
        date.setDate(date.getDate()-1);
        if(date.getMonth()<9 && date.getDate()<10) return date.getFullYear()+'-0'+(date.getMonth()+1)+'-0'+date.getDate();
        if(date.getMonth()<9) return date.getFullYear()+'-0'+(date.getMonth()+1)+'-'+date.getDate();
        if(date.getDate()<10) return date.getFullYear()+'-'+(date.getMonth()+1)+'-0'+date.getDate();
        return date.getFullYear()+'-'+(date.getMonth()+1)+'-'+date.getDate()},
      getBanksCatalog(){
        axios.get( '/api/accounting/banks/catalog').then(response => {
          this.catalog = response.data.data;
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('No se ha podido cargar el catálogo', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      loadCSV(e) {
        let vm = this;
        if (window.FileReader) {
          let reader = new FileReader();
          if(e.target.files.length < 1) return;
          reader.readAsText(e.target.files[0]);
          // Handle errors load
          reader.onload = function(event) {
            let csv = event.target.result;
            vm.parse_csv = vm.convertCsvtoJSON(csv)
          };
          reader.onerror = function(evt) {
            if(evt.target.error.name === "NotReadableError") {
              Vue.toasted.show('No se pudo leer el archivo', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
            }
          };
        } else {
          Vue.toasted.show('El Lector de Archivos (FileReader) no esta soportado en este navegador', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        }
      },
      convertCsvtoJSON(csv){
        let cabeceras = 'fecha,descripcion,referencia,cargo,abono,saldo,concepto';
        let vm = this;
        let lines = csv.split("\n");
        let result = [];
        let headers = null;
        if(this.containHeaders){
          headers = lines[0].split(",");
          vm.parse_header = lines[0].split(",");
          lines[0].split(",").forEach(function (key) {
            vm.sortOrders[key] = 1
          });
        } else {
          headers = cabeceras.split(",");
          vm.parse_header = cabeceras.split(",");
          cabeceras.split(",").forEach(function (key) {
            vm.sortOrders[key] = 1
          });
        }

        lines.map(function(line, indexLine){
          if (indexLine < 1 && vm.containHeaders === true) return; // Jump header line

          let obj = {};
          let currentline = line.split(",");

          headers.map(function(header, indexHeader){
            obj[header] = currentline[indexHeader]
          });

          result.push(obj)
        });

        result.pop(); // remove the last item because undefined values

        return result; // JavaScript object
      },
      mostrar(){
        Vue.toasted.show('Cargando '+this.file+'...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/accounting/statements/check', {
          fecha: this.fecha,
          bank: this.bank
        }).then(response => {
          this.mensajes = response.data.data;
          if(response.data.saldo != null){
            if(response.data.saldo != this.parse_csv[0].saldo){
              this.mensajes.push('El saldo final del día anterior para este banco no coincide con el saldo del primer registro');
            }
          }
          let data = [];
          let auxdate = new Date(this.fecha);
          auxdate.setDate(auxdate.getDate()+1);
          let auxstring = auxdate.getFullYear()+'/'+auxdate.getMonth()+'/'+auxdate.getDate();
          let lanzado = false;
          var BreakException = {'mensaje': 'Fecha del Estado de Cuenta no coincide con Fecha Seleccionada'};
          try{
            this.parse_csv.forEach(function (item) {
              if(item.fecha != ""){
                //if(item.fecha === auxstring){
                  data.push(item);
                // } else {
                //   throw BreakException;
                // }
              }
            });
          } catch (e) {
            if(e !== BreakException) throw e;
            else {
              lanzado = true;
              Vue.toasted.clear();
              this.mensajes.push(e.mensaje);
            }
          }

          this.data = data;
          if(!lanzado){
            Vue.toasted.clear();
            Vue.toasted.show('¡¡'+this.file+' cargado correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
          }
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      vaciarVista(){
        this.data = [];
        this.file = null;
        this.parse_csv = [];
        this.parse_header = [];
        this.sortOrders = {};
        this.containHeaders = false;
        this.mensajes = [];
      },
      noMovements(){
        this.vaciarVista();
        Vue.toasted.show('Revisando saldo final del día anterior para este banco...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/accounting/statements/check', {
          fecha: this.fecha,
          bank: this.bank
        }).then(response => {
          Vue.toasted.clear();
          Vue.toasted.show('¡¡Saldo revisado correctamente para este banco!!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
          this.mensajes = response.data.data;
          var fecha = new Date(this.fecha);
          fecha.setDate(fecha.getDate()+1);
          this.data.push({
            fecha: this.format_date(fecha, '/'),
            descripcion: 'Sin Movimientos',
            referencia: 'SM',
            cargo: 0,
            abono: 0,
            saldo: response.data.saldo == null ? 0 : response.data.saldo,
            concepto: 'Sin Movimientos',
          });
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      deleteDayMovements(){
        axios.post( '/api/accounting/statements/check', {
          fecha: this.fecha,
          bank: this.bank
        }).then(response => {
          if(response.data.borrar){
            this.show = false;
            Vue.toasted.show('Borrando movimientos...', { position: 'bottom-center', closeOnSwipe: false });
            axios.post( '/api/accounting/statements/delete', {
              fecha: this.fecha
            }).then(response => {
              Vue.toasted.clear();
              Vue.toasted.show('¡¡Movimientos borrados correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
            }).catch(error => {
              Vue.toasted.clear();
              Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
            });
          } else {
            Vue.toasted.show('¡Existen movimientos con llave de conciliación para este día! Desconcilie primero para poder borrar',
                    { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
          }
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      },
      saveMovements(){
        if(this.bank !== null){
          Vue.toasted.show('Guardando movimientos...', { position: 'bottom-center', closeOnSwipe: false });
          axios.post( '/api/accounting/statements/check', {
            fecha: this.fecha,
            bank: this.bank
          }).then(response => {
            if(response.data.borrar){
              axios.post( '/api/accounting/statements/delete', {
                fecha: this.fecha
              }).then(response => {
                axios.post( '/api/accounting/statements/save', {
                  movements: this.data,
                  bank: this.bank
                }).then(response => {
                  Vue.toasted.clear();
                  Vue.toasted.show('¡¡Movimientos guardados correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
                }).catch(error => {
                  Vue.toasted.clear();
                  Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
                });
              }).catch(error => {
                Vue.toasted.clear();
                Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
              });
            } else {
              Vue.toasted.clear();
              Vue.toasted.show('¡Existen movimientos con llave de conciliación para este día! Desconcilie primero para poder modificar',
                      { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
            }
          }).catch(error => {
            Vue.toasted.clear();
            Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
          });
        } else {
          Vue.toasted.show('Seleccione un banco primero', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        }
      },
      format_date(date){
        var fecha = new Date(date);
        if(fecha.getMonth()<9 && fecha.getDate()<10) return '0'+fecha.getDate()+'/'+'0'+(fecha.getMonth()+1)+'/'+fecha.getFullYear();
        if(fecha.getMonth()<9) return fecha.getDate()+'/'+'0'+(fecha.getMonth()+1)+'/'+fecha.getFullYear();
        if(fecha.getDate()<10) return '0'+fecha.getDate()+'/'+(fecha.getMonth()+1)+'/'+fecha.getFullYear();
        return fecha.getDate()+'/'+(fecha.getMonth()+1)+'/'+fecha.getFullYear();
      },
      loadMovements(){
        this.vaciarVista();
        this.loading = true;
        Vue.toasted.show('Cargando movimientos...', { position: 'bottom-center', closeOnSwipe: false });
        axios.post( '/api/accounting/statements/get', {
          fecha: this.fecha,
          bank: this.bank
        }).then(response => {
          this.loading = false;
          Vue.toasted.clear();
          Vue.toasted.show('¡¡Movimientos cargados correctamente !!', { position: 'bottom-center', type:'success', closeOnSwipe: false, duration: 10000 });
          this.data = response.data.data;
        }).catch(error => {
          Vue.toasted.clear();
          Vue.toasted.show('Ha ocurrido un error', { position: 'bottom-center', type:'error', closeOnSwipe: true, duration: 10000});
        });
      }
    },
    watch: {
      fecha: function () {
        this.vaciarVista();
        if(this.bank !== null){
          this.loadMovements();
        }
      },
      bank: function () {
        if(this.fecha !== null){
          this.loadMovements();
        }
      }
    }
}
</script>
